module.exports = __webpack_public_path__ + "img/whatsapp_green.e27e9ae.svg";